import { Component, OnInit, Optional, Inject, SecurityContext, OnDestroy } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MatDialogConfig,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ApiService } from 'src/app/common/services/api.service';
import { MessageService } from 'src/app/common/services/message.service';
import { CommonService } from 'src/app/common/services/common.service';
import { UtilService } from 'src/app/util/util.service';
import { EventTrackerService } from 'src/app/common/services/event-tracker.service';
import { HttpHeaders } from '@angular/common/http';
import { CurrencyService } from 'src/app/util/currency.service';
import { saveAs } from 'file-saver/dist/FileSaver';
import { resolveHostedUrl } from 'src/app/constants/hosted-api-urls';
import { LocalStorageService } from '../../services/localStorage.service';
import { RNDataTransferService } from '../../services/rn-data-transfer.service';
import { CashierActionType } from 'src/app/invoice/models/enums/invoice.enum';
import { CROSS } from 'src/defaultImages.js';
import { DomSanitizer} from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { BillingCountersDataService } from '../../services/billing-counters-data.service';
import { EasyEatHqService } from '../../services/ee-hq.service';
@Component({
  selector: 'app-cashier-confirmation',
  templateUrl: './cashier-confirmation.component.html',
  styleUrls: ['../update-cash/update-cash.component.css', './cashier-confirmation.component.css'],
})
export class CashierConfirmationComponent implements OnInit, OnDestroy {
  images = {
    CROSS: CROSS,
  };
  Currency;
  now = new Date();
  cashier_report;
  subscription: Subscription = new Subscription();
  translationText: any;
  billingCounterName: string = '';
  billingCounterInfo: string = '';
  isHq: boolean = false;
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private message: MessageService,
    private commonService: CommonService,
    private _hqService: EasyEatHqService,
    private util: UtilService,
    private _eventTracker: EventTrackerService,
    private curr: CurrencyService,
    private _localStorage: LocalStorageService,
    private _rnDataTransferService: RNDataTransferService,
    private _sanitizer: DomSanitizer,
    private _translateService: TranslateService,
    private _counterDataService: BillingCountersDataService
  ) {
    this.Currency = this.curr.getCurrency();
    this.isHq = this._hqService.hqStatus;
    if (data.type == 'cashier-report') {
      if(!this.isHq){
        this.billingCounterName = data?.counter_name;
      }
      if (data.cashierData) this.getCashierReportDataByEpoch();
      else this.fetchCashierReport();
    }
  }

  ngOnInit() {
    this.setTranslations();
    this.getBillingCounterName();
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  private getBillingCounterName(): void {
    this.subscription.add(
      this._counterDataService
        .getMappedBillingCounterName()
        .subscribe((mappedCounterName) => {
          if(!this.billingCounterName){
            this.billingCounterName = mappedCounterName;
          }
          if (this.billingCounterName) {
            const subHeadingType: { [key: string]: string } = {
              'cashier-report': 'BILLING_CASHIER_REPORT',
              'close-cashier': 'CLOSING_CASHIER',
              'open-cashier': 'OPENING_CASHIER',
            };
            const subHeading = subHeadingType[this.data?.type];
            if (subHeading) {
              this.setSubHeading(subHeading);
            }
          }
        })
    );
  }
  private setTranslations(): void {
    this.subscription.add(
      this._translateService
        .get('OPEN_CASH_DRAWER')
        .subscribe((translation) => {
          this.translationText = translation;
        })
    );
  }
  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
    if (this.data.type == 'cashier-report')
      this.commonService.sendMessage({ data: 'refresh', success: 1 });
  }
  async continue_clicked() {
    const { UpdateCashierComponent } = await import(
      /* webpackPrefetch: true */
      'src/app/invoice/modals/update-cashier/update-cashier.component'
    );
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    const dialogRef = this.dialog.open(UpdateCashierComponent, {
      backdropClass: 'backdrop',
      maxHeight: '90vh',
      data: {
        type: this.data.type,
        restaurant_id: this.data.restaurant_id,
      },
      maxWidth: '100vw',
    });
    if (this.data.type === CashierActionType.closeCashier) {
      this.drawer_kick();
    }
    this.cancel_clicked();
    dialogRef.afterClosed().subscribe((result: any) => {
      // if(result.data == 'success') this.commonService.sendMessage({data:'refresh', success:1})
    });
  }
  print_clicked() {
    // Send data to React
    if (this.util.cashRegistryEnabled()) {
      const payload = {
        action: 'cashier_report_print',
        restaurant_id: this.data.restaurant_id,
        receipt_type: 'report',
      };
      if(this.data.cashierData) {
        payload['start_epoch'] = this.data.cashierData.open_epoch;
        payload['end_epoch'] = this.data.cashierData.close_epoch;
        payload['time_zone'] = localStorage.getItem('time_zone');
      }
      const isMultiCashDrawerEnabled = this.util.isMultiCashDrawerEnabled();
      if(isMultiCashDrawerEnabled) {
        const deviceId = this.util.getDeviceUID();
        payload['device_id'] = deviceId;
      }
      // for react devices
      this.util.send_data_to_react(payload);

      // for windows devices
      this.util.sendEodPrintCommand(this.data.restaurant_id, 'report');
    }
    // this.done_clicked();
    this._eventTracker.easyeat_track_event('CASHIER_REPORT_PRINTED', {});
  }
  isForceCloseCashierEnabled() {
    let forceClose_enabled = 0;
    try {
      let restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      forceClose_enabled = restSettings['global']['force_close_cash_mgt'];
    } catch (error) {}
    return forceClose_enabled;
  }
  done_clicked() {
    this.dialogRef.close({ data: 'closed' });
    if (this.data.type == 'cashier-report')
      this.commonService.sendMessage({ data: 'refresh', success: 1 });
  }
  fetchCashierReport() {
    let rest_id = this.data.restaurant_id;
    let httpOptions: { headers } = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${
          this.data.authToken
            ? this.data.authToken
            : localStorage.getItem('token')
        }`,
      }),
    };
    const deviceId = this.util.getDeviceUID();
    this.apiService.getCloseCashierReport(rest_id, httpOptions, deviceId).subscribe(
      (res: any) => {
        if (res.statusCode == 200) {
          this.cashier_report = res.data;
        }
      },
      (error) => {
        this.message.showError(error.error.message);
      }
    );
  }
  
  getCashierReportDataByEpoch() {
    const payload = {
      restaurant_id: this.data.restaurant_id,
      start_epoch: this.data.cashierData.open_epoch,
      end_epoch: this.data.cashierData.close_epoch,
    };
    if(!this.isHq && this.data.cashierData?.device_id){
      payload['device_id']=this.data.cashierData?.device_id
    }
    this.apiService.getCashierReportDataByEpoch(payload).subscribe(
      (response: any) => {
        if (response.statusCode == 201) {
          this.cashier_report = {...response.data,...this.data.cashierData};
          this.data['cashTally'] =
            this.cashier_report.actual_cash_in_drawer !==
            this.cashier_report.expected_cash_in_drawer
              ? 1
              : 0;
        }
      },
      (error) => {
        this.message.showError(error.error.message);
      }
    )
  }

  downloadCashierReport(){
    const deviceId = this.util.getDeviceUID();
    const payload = {
      restaurant_id: this.data.restaurant_id,
      start_epoch_time: this.data.cashierData.open_epoch,
      end_epoch_time: this.data.cashierData.close_epoch,
      device_ids: this.data?.cashierData?.device_id ? [this.data.cashierData.device_id] : []
    }
    if (this.util.isReactDevice()) {
      const eventData = {
        endpoint: `${resolveHostedUrl('nestURL')}/api/cash-mgt/cash-report/download`,
        payload: payload,
      };
      this._rnDataTransferService.sendDownloadCustomReportActionToRN(eventData);
      return;
    }
    this.apiService.downloadCashierReportData(payload).subscribe(
      (response) => {
        if (response.statusCode == 201) {
          saveAs(response.data, this.util.generateFileName(response.data));
        }
      },
      (error) => {
        this.message.showError((error.error || {}).message);
      });
  }

  drawer_kick() {
    const restaurant_id = this._localStorage.get('restaurant_id');
    const payload = {
      restaurant_id: restaurant_id,
      staff_name: this._localStorage.get('user_name'),
      reason: 'Close Cashier',
      device_id: this.util.getDeviceUID()
    };
    this.apiService.addDrawerKickDetails(payload).subscribe(
      (response) => {
        if ((response || {}).statusCode == 201) {
          // Send data to React
          if (this.util.cashRegistryEnabled()) {
            const isMultiCashDrawerEnabled = this.util.isMultiCashDrawerEnabled();
            const deviceId = this.util.getDeviceUID();
            const data = {
              restaurant_id: restaurant_id,
              txn_id: ((response || {}).data || {}).txn_id,
              dkick_code: this._localStorage.get('dkick_code'),
              action: 'drawer-kick',
              ...(isMultiCashDrawerEnabled && { device_id: deviceId }),
            };
            this.util.send_data_to_react(data, 'drawer-kick');
            this.util.openCashDrawer();
            this.util.openCashDrawerPrintReceipt(
              {
                restaurant_id: restaurant_id,
                txn_id: ((response || {}).data || {}).txn_id,
              },
              'drawer-kick'
            );
          }
          this.dialogRef.close({ data: 'success' });
        }
        this._localStorage.set('temp_access_token', null);
      },
      (error) => {
        this.dialogRef.close({ data: 'closed' });
        this._localStorage.set('temp_access_token', null);
      }
    );
  }

  private setSubHeading(translationString: string): void {
    const counterSubHeading = this.translationText[translationString]?.replace(
      '{{billingCounterName}}',
      this.billingCounterName
    );
    this.sanitizeHtml(counterSubHeading);
  }
  private sanitizeHtml(html: string): void {
    this.billingCounterInfo = this._sanitizer.sanitize(
      SecurityContext.HTML,
      html
    );
  }
}
